<template>
  <div class="policy-container" v-html="content"></div>
</template>

<script>
import faqHtml from '../../../public/Faq.html?raw'
import tosHtml from '../../../public/TermsOfService.html?raw'
import privacyHtml from '../../../public/PrivacyPolicy.html?raw'
import cookieHtml from '../../../public/CookiePolicy.html?raw'

const htmlMap = {
  Faq: faqHtml,
  TermsOfService: tosHtml,
  PrivacyPolicy: privacyHtml,
  CookiePolicy: cookieHtml,
};

export default {
  name: 'PolicyPage',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['terms', 'privacy', 'cookie', 'faq'].includes(value)
    }
  },
  data() {
    return {
      content: ''
    }
  },
  computed: {
    policyFile() {
      const fileMap = {
        terms: 'TermsOfService',
        privacy: 'PrivacyPolicy',
        cookie: 'CookiePolicy',
        faq: 'Faq'
      };
      return fileMap[this.type] || 'TermsOfService';
    },
    isAppMode() {
      return new URLSearchParams(window.location.search).get('mode') === 'app';
    }
  },
  mounted() {
    const html = htmlMap[this.policyFile];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const style = doc.querySelector('style');

    if (style) {
      const styleElement = document.createElement('style');
      styleElement.textContent = style.textContent;
      document.head.appendChild(styleElement);
    }

    this.content = doc.body.innerHTML;

    if (this.isAppMode) {
      document.body.classList.add('policy-page');
    }
  },
  beforeUnmount() {
    document.body.classList.remove('policy-page');
    const addedStyle = document.head.querySelector('style');
    if (addedStyle) {
      addedStyle.remove();
    }
  }
};
</script>

<style scoped>
.policy-container {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}
</style>
